import { map } from 'rxjs';
import { convertUnixToDate } from '@golden/utils';
import { ADMIN_API } from '../AdminAPI';
export function createJumpShipService(api) {
    return {
        validateStaffAccount: (account) => {
            return api.fetch(ADMIN_API.POST_VALIDATE_STAFF_ACCOUNT, { data: { account } });
        },
        validate: (data) => {
            return api.fetch(ADMIN_API.POST_VALIDATE_JUMP_SHIP, { data });
        },
        createJumpShipRequisition: (data) => {
            return api.fetch(ADMIN_API.POST_PLAYER_JUMP_SHIP, { data });
        },
        getJumpShipList: (data) => {
            return api.fetch(ADMIN_API.GET_PLAYER_JUMP_SHIP_RECORD, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'operate_at', 'canceled_at', 'processed_at'))
            })));
        },
        cancelJumpShip: (id) => {
            return api.fetch(ADMIN_API.DELETE_PLAYER_JUMP_SHIP, { config: { urlParams: { id } } });
        }
    };
}
//# sourceMappingURL=JumpShipService.js.map